import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast, ToastContainer } from "react-toastify";
import FormHandler from "../../Common/Form/FormHandler/FormHandler";
import { ExecuteSopsConfig, sopformschema } from "./ExecuteSopsConfig";
import { useTranslation } from "react-i18next";
import {
  getData,
  postDataWithBody,
  putDataWithBody,
  getDataById,
} from "../../../../Services/Services";

import {
  getTaskConfigsURL,
  createTaskURL,
  findTaskById,
  getTaskListURL,
  updateTaskURL,

  SopTaskTableData,

  sopGetIncident,
  SopUserData,
  CreateSopInstance,

  getAllSopByIncident,

  getAllIncidentsByCtegorySopForLadakh,
  getThemeURL,
  getActiveMasterSOPById,
} from "../../../../Services/EndPoints";

import Loader from "react-spinner-loader";
import { downloadFile } from "../../../../Components/UiComponents/utils";
import { PaperClipIcon } from "../../../../Components/IconComponents";
import { useKeycloak } from "@react-keycloak/web";
import ExecuteSopsExpandableTable from "./ExecuteSopsExpandableTable";

// Epoch-millis / ISO string → "02-09-2026 03:49 PM"
const formatFailureTime = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  let h = d.getHours();
  const min = String(d.getMinutes()).padStart(2, "0");
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${dd}-${mm}-${yy} ${String(h).padStart(2, "0")}:${min} ${ampm}`;
};

const ExecuteSopsForm = () => {
  const { t } = useTranslation();
  const [sopTableData, setSopTableData] = useState([]);
  const [stateId, setStateId] = useState(null);
  const [userTaskData, setUserTaskData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [isFieldsDisabled, setIsFieldsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [sopFormConfig, setSopFormConfig] = useState(() =>
    ExecuteSopsConfig.map(tab => ({ ...tab, fields: tab.fields.map(f => ({ ...f, options: [] })) }))
  );
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [taskConfigs, setTaskConfigs] = useState([]);
  const [viewTaskDetails, setViewTaskDetails] = useState(null);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [overallPriority, setOverallPriority] = useState("Low");
  const [hasSelectedTasks, setHasSelectedTasks] = useState(false);
  const [Description, setDescription] = useState(false);
  const [incidentList, setIncidentList] = useState([]); // Store incident list
  const [sopResources, setSopResources] = useState([]);
  const [checkedResources, setCheckedResources] = useState({});
  const [isResourcesExpanded, setIsResourcesExpanded] = useState(true);
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  const selectedRegionIdRef = useRef(null);
  // Guards the one-time "Auto SOP Failed" pre-selection so later category
  // changes behave normally.
  const autoSopHandledRef = useRef(false);

  console.log("one", sopTableData)
  console.log("one1", isFieldsDisabled)
  console.log("one2", taskConfigs)
  console.log("one3", viewTaskDetails)
  console.log("one4", overallPriority)
  console.log("one5", selectedRegionId)


  const { state } = useLocation();
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  console.log("oo", setSopTableData)
  console.log("oo1", setOverallPriority)
  console.log("oo2", setActiveTabIndex)
  console.log("oo3", setIsFieldsDisabled)
  const taskId = state?.data?.id;
  const mediaFilePath = state?.data?.media_file_path;
  // Set when arriving from an incident's "Auto SOP Failed" Quick Link — used
  // to pre-select that incident's category + incident in this form.
  const autoSopIncident = state?.autoSopIncident || null;

  useEffect(() => {
    setDescription(true);
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: (sopformschema && sopformschema[activeTabIndex]) ? yupResolver(sopformschema[activeTabIndex]) : undefined,
    mode: "all",
  });

  // Watch for changes in dropdown values
  const selectedSopId = watch("task_name");
  const selectedIncidentId = watch("incident_type_id");
  const incidentcatgeoryId = watch("indident_category");

  console.log(incidentcatgeoryId, "incidentcategory");

  // Coming from "Auto SOP Failed": once the category list is loaded, select
  // the incident's category by name — that cascades to the incident dropdown,
  // where fetchIncidentTypes then pre-selects this incident by id.
  useEffect(() => {
    if (!autoSopIncident?.category || !Array.isArray(taskConfigs) || taskConfigs.length === 0) return;
    const cat = taskConfigs.find(
      (c) =>
        c.category_name === "INCDNT_CAT" &&
        String(c.value).trim().toLowerCase() === String(autoSopIncident.category).trim().toLowerCase()
    );
    if (cat) setValue("indident_category", String(cat.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskConfigs]);

  // NEW: fetch stateId once on mount
  useEffect(() => {
    const initializeStateId = async () => {
      try {
        const userProfile = await getData(getThemeURL);
        setStateId(userProfile[0]?.state_id);
      } catch (error) {
        console.error("Failed to fetch state_id:", error);
      }
    };
    initializeStateId();
  }, []);

  // CHANGED: wait for stateId before initializing
  useEffect(() => {
    if (stateId === null) return;
    loadInitialData();
    fetchSopUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateId]);

  // Add a useEffect to watch for category changes
  useEffect(() => {
    // If a valid category is selected, fetch the related data
    fetchIncidentTypes();
    fetchViewData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incidentcatgeoryId]);

  // Watch for incident type changes — derive severity, region and re-fetch SOPs
  useEffect(() => {
    if (selectedIncidentId && incidentList.length > 0) {
      const selectedIncident = incidentList.find(
        (incident) => incident.id === parseInt(selectedIncidentId)
      );
      const severity = selectedIncident?.severity || "N/A";
      const regionId = selectedIncident?.parent_region_id || null;
      setValue("severity_display", severity);
      setSelectedRegionId(regionId);
      selectedRegionIdRef.current = regionId;
      fetchSopList(severity);
    } else {
      setValue("severity_display", "");
      setSelectedRegionId(null);
      selectedRegionIdRef.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIncidentId, incidentList]);

  useEffect(() => {
    if (selectedSopId && incidentcatgeoryId) {
      fetchTaskList();

      // Fetch SOP resources from master SOP
      if (stateId) {
        const regionParam = selectedRegionIdRef.current ? `&regionId=${selectedRegionIdRef.current}` : "";
        getData(`${getActiveMasterSOPById}/${stateId}?sopId=${selectedSopId}${regionParam}`)
          .then((res) => {
            const sopData = Array.isArray(res) ? res?.[0] : null;
            const resources = sopData?.resources ?? null;
            const filtered = resources?.filter(r => r.resource_name) || [];
            setSopResources(filtered);
            // Pre-check all resources by default
            const defaultChecked = {};
            filtered.forEach((r, i) => { defaultChecked[r.resourceId ?? i] = true; });
            setCheckedResources(defaultChecked);
            // Set region name from API response
            setValue("region_name_display", sopData?.region_name || "");
          })
          .catch(() => { setSopResources([]); setCheckedResources({}); setValue("region_name_display", ""); });
      }

      // Find the selected SOP
      const selectedSop = availableRoles.find(
        (sop) => sop.id === parseInt(selectedSopId)
      );

      if (selectedSop) {
        // Update the description field with the selected SOP's description
        setValue("description", selectedSop.description, {
          shouldValidate: true,
          shouldDirty: true,
        });

        const now = new Date();
        const formattedDate = now
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-"); // Format as DD-MM-YYYY
        const formattedTime = now.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });

        // Combine SOP name with date and time
        const nameValue = `${selectedSop.name}_${formattedDate} ${formattedTime}`;

        setValue("assign_to_id", nameValue, {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    } else {
      setSopResources([]);
      setValue("region_name_display", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSopId, availableRoles, incidentcatgeoryId]);

  useEffect(() => {
    if (selectedIncidentId) {
      fetchSopIncident();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIncidentId]);

  // Effect to update button state based on task selection
  useEffect(() => {
    const anyTaskSelected = userTaskData.some((task) => task.isSelected);
    setHasSelectedTasks(anyTaskSelected);
  }, [userTaskData]);


  const fetchSopIncident = async () => {
    setIsLoading(true);
    try {
      const response = await getDataById(sopGetIncident, selectedIncidentId);
      console.log("SOP Incident Data:", response);
    } catch (error) {
      console.error("Error fetching SOP incident:", error);
      toast.error(t("fetch_error_message"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSopUserData = async () => {
    setIsLoading(true);
    try {
      const response = await getDataById(SopUserData, selectedSopId);
      console.log("SOP User Data:", response);
    } catch (error) {
      console.error("Error fetching SOP user data:", error);
      toast.error(t("fetch_error_message"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const loadInitialData = async () => {
    setIsLoading(true);
    await fetchTaskConfigs();
    if (taskId) {
      populateFormForEdit(taskId);
    }
    setIsLoading(false);
  };

  const fetchTaskConfigs = async () => {
    try {
      const res = await postDataWithBody(
        `${getTaskConfigsURL}/${stateId}`,
        ["INCDNT_CAT"],
        {}
      );

      setTaskConfigs(res); // Store raw config data

      // Process incident categories with hardcoded "Select Category" option
      const incidentCategories = [
        { label: "Select Category", value: "" }, // Added hardcoded first value
        ...res
          .filter(config => config.category_name === "INCDNT_CAT")
          .map(config => ({
            label: config.value,
            value: config.id,
          }))
      ];

      // Update the form config with incident categories
      const updatedConfig = [...sopFormConfig];
      if (updatedConfig[0] && updatedConfig[0].fields && updatedConfig[0].fields[0]) {
        updatedConfig[0].fields[0].options = incidentCategories;
        setSopFormConfig(updatedConfig);
      }

    } catch (error) {
      console.error("Failed to fetch task configs:", error);
    }
  };

  const fetchIncidentTypes = async () => {
    if (!incidentcatgeoryId) {
      updateFormConfig(0, 1, []);
      setIncidentList([]);
      setValue("incident_type_id", "");
      setValue("severity_display", "");
      return;
    }

    // Reset previous selection when category changes
    setValue("incident_type_id", "");
    setValue("severity_display", "");

    try {
      const res = await getData(getAllIncidentsByCtegorySopForLadakh + incidentcatgeoryId + "?stateId=" + stateId);
      console.log("Incident Types Response:", res);
      let incidentTypes = Array.isArray(res) ? res : [];

      // Coming from "Auto SOP Failed": that incident may no longer be
      // SOP-eligible (so it's absent from this list) — inject it once so it
      // can still be shown and pre-selected in the Incident dropdown.
      const applyAutoSop = autoSopIncident?.id != null && !autoSopHandledRef.current;
      if (applyAutoSop && !incidentTypes.some((t) => String(t.id) === String(autoSopIncident.id))) {
        incidentTypes = [
          {
            id: autoSopIncident.id,
            name: autoSopIncident.name,
            severity: autoSopIncident.severity,
            parent_region_id: autoSopIncident.parent_region_id,
          },
          ...incidentTypes,
        ];
      }

      // Store the full incident list for later use
      setIncidentList(incidentTypes);

      const formattedTypes =
        incidentTypes.length > 0
          ? incidentTypes.map((type) => ({
            label: type.name,
            value: type.id,
          }))
          : [{ label: "No options available", value: "" }];

      updateFormConfig(0, 1, formattedTypes);

      if (incidentTypes.length > 0) {
        // Pre-select the "Auto SOP Failed" incident if present, else the first.
        const preMatch = applyAutoSop
          ? incidentTypes.find((t) => String(t.id) === String(autoSopIncident.id))
          : null;
        if (preMatch) autoSopHandledRef.current = true;
        const chosen = preMatch || incidentTypes[0];
        setValue("incident_type_id", String(chosen.id));
        // Set severity immediately using the data we already have
        const severity = chosen?.severity || autoSopIncident?.severity || "N/A";
        setValue("severity_display", severity);
        fetchSopList(severity);
      } else {
        fetchSopList(null);
      }
    } catch (error) {
      console.error("Failed to fetch incident types:", error);
      updateFormConfig(0, 1, [{ label: "No options available", value: "" }]);
      setIncidentList([]);
      fetchSopList(null);
    }
  };


  const fetchSopList = async (severity) => {
    if (!incidentcatgeoryId) {
      updateFormConfig(0, 4, []);
      setAvailableRoles([]);
      setValue("assign_to_id", "");
      return;
    }

    try {
      const severityParam = severity && severity !== "N/A" ? `&severity=${encodeURIComponent(severity)}` : "";
      const sops = await getData(getAllSopByIncident + incidentcatgeoryId + "?stateId=" + stateId + severityParam);
      setAvailableRoles(sops);

      const formattedSops =
        sops.length > 0
          ? sops.map((sop) => ({
            label: sop.name,
            value: sop.id,
          }))
          : [{ label: "No options available", value: "" }];

      updateFormConfig(0, 4, formattedSops);

      if (sops.length > 0) {
        const defaultSopId = sops[0].id.toString();
        setValue("task_name", defaultSopId);

        setValue("description", sops[0].description, {
          shouldValidate: true,
          shouldDirty: true,
        });

        const now = new Date();
        const formattedDate = now.toLocaleDateString("en-GB").replace(/\//g, "-");
        const formattedTime = now.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });

        const nameValue = `${sops[0].name}_${formattedDate} ${formattedTime}`;
        setValue("assign_to_id", nameValue, {
          shouldValidate: true,
          shouldDirty: true,
        });

        fetchTaskList(defaultSopId);
      } else {
        setValue("assign_to_id", "", {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    } catch (error) {
      console.error("Failed to fetch SOP list:", error);
      updateFormConfig(0, 4, [{ label: "No options available", value: "" }]);
      setAvailableRoles([]);
      setValue("assign_to_id", "", {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };


  const updateFormConfig = (configIndex, fieldIndex, options) => {
    const updatedConfig = [...sopFormConfig];
    if (updatedConfig[configIndex] && updatedConfig[configIndex].fields && updatedConfig[configIndex].fields[fieldIndex]) {
      updatedConfig[configIndex].fields[fieldIndex].options = options;
      setSopFormConfig(updatedConfig);
    }
  };

  const fetchViewData = async () => {
     await getData(getTaskListURL.replace("STATEID", stateId));
    if (taskId) {
      populateFormForEdit(taskId);
    }
  };

  const populateFormForEdit = async (id) => {
    const response = await postDataWithBody(findTaskById, [id], {});
    const taskData = response[0];
    setViewTaskDetails(taskData);
    reset(taskData);
  };

  const generateTabsContent = (tabData) => {
    tabData?.forEach((tab) => {
      tab.component = generateFormFields(
        tab?.fields,
        register,
        errors,
        control
      );
    });
    return tabData;
  };

  const generateFormFields = (fields, register, errors, control) => {
    return (
      <div>
        <div
          style={{
            marginLeft: "15px",
            marginTop: "1rem",
            marginBottom: "1rem",
            color: "#17a3a0",
            fontSize: "17px",
            fontWeight: "700px"
          }}
        >
          Basic Information
        </div>
        <FormHandler
          register={register}
          errors={errors}
          fields={fields}
          control={control}
          editId={taskId}
          columns={2}
          getValues={getValues}
          fileObjs={attachedFiles}
          setFileObjs={setAttachedFiles}
          Description={Description}
        />
      </div>
    );
  };

  const fetchTaskList = async (sopId = selectedSopId) => {
    // Only proceed if we have both incident category and SOP selected
    if (!incidentcatgeoryId || !sopId) {
      setUserTaskData([]);
      setRowCount(0);
      return;
    }

    setIsLoading(true);
    try {
      const response = await getDataById(SopTaskTableData, sopId);
      const sortedTasks = response
        ? response.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
        : [];

      // Add isSelected property to each task
      const tasksWithSelection = sortedTasks.map((task) => ({
        ...task,
        isSelected: false,
        priority: task.task_status_code || "Low", // Default priority if not provided
      }));

      setUserTaskData(tasksWithSelection);
      setRowCount(tasksWithSelection.length);
    } catch (error) {
      console.error("Error fetching task list:", error);
      toast.error(t("fetch_error_message"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormSubmit = async (data, e) => {
    setIsLoading(true);
    setIsSubmitting(true);
    e.preventDefault();

    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (key === "task_media_file" && value?.length > 0) {
        Array.from(value).forEach((file) => formData.append(key, file));
      } else {
        formData.append(key, value);
      }
    });

    formData.append("status", true);
    if (taskId) formData.append("id", taskId);

    try {
      const headers = { "Content-Type": "multipart/form-data" };
      const response = taskId
        ? await putDataWithBody(updateTaskURL, formData, headers)
        : await postDataWithBody(createTaskURL, formData, headers);

      if (response.status === "success") {
        toast.success(response.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        navigate("/planning/view-task");
      } else {
        toast.error(response.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Form submission error:", error);
      toast.error(t("submission_error"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
    }
  };

  // Convert string priority to numeric value
  const getPriorityNumericValue = (priority) => {
    switch (priority) {
      case "Low":
        return 0;
      case "Medium":
        return 1;
      case "High":
        return 2;
      default:
        return 0; // Default to Low
    }
  };

  const handleTaskSelection = (rowId, isSelected) => {
    setUserTaskData((prevData) =>
      prevData.map((row) => {
        if (row.id === rowId) {
          return { ...row, isSelected };
        }
        return row;
      })
    );
  };

  const handlePriorityChange = (rowId, priority) => {
    // Convert string priority to numeric value
    const priorityValue = getPriorityNumericValue(priority);

    setUserTaskData((prevData) =>
      prevData.map((row) => {
        if (row.id === rowId) {
          return { ...row, priority, priorityValue };
        }
        return row;
      })
    );
  };

  const ExecuteSop = async () => {
    setIsLoading(true);
    setIsSubmitting(true);

    try {
      // Get form data
      const formData = getValues();

      // Debug: Log form data to see what's being captured
      console.log("=== DEBUG: Form Data ===");
      console.log("All form data:", formData);

      // Get selected tasks
      const selectedTasksList = userTaskData.filter((task) => task.isSelected);

      if (selectedTasksList.length === 0) {
        toast.warning(t("Please select at least one task to execute"), {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        setIsSubmitting(false);
        setIsLoading(false);
        return;
      }

      // Create taskWrapperList
      const taskWrapperList = selectedTasksList.map((task) => ({
        id: task.id.toString(),
        name: task.name,
        type: task.task_type === 0 ? "Activity" : "Notification",
        priority: getPriorityNumericValue(task.priority),
        incidentType: task.incidenttype,
        assignedTo: task.assignedto,
        role: task.role || 0,
        taskId: task.id,
        status: "TASK_EXE_STATUS_NEW_TASK",
      }));

      // Build resourceWrapperList from checked resources
      const resourceWrapperList = sopResources
        .filter((r, i) => checkedResources[r.resourceId ?? i])
        .map((r) => ({
          resourceId: r.resourceId,
          resourceName: r.resource_name,
          facilityId: r.facility_id,
        }));

      // Create payload
      const payload = {
        incidentId: parseInt(selectedIncidentId),
        sopId: parseInt(selectedSopId),
        name: formData.assign_to_id,
        description: formData.description,
        userId: keycloak.tokenParsed?.email || "dmsadmin@bihar.gov.in",
        status: "TASK_EXE_STATUS_NEW_TASK",
        executeStatus: true,
        stateId: stateId,
        taskWrapperList,
        resourceWrapperList,
      };

      console.log("=== DEBUG: Final Payload ===");
      console.log("Execute SOP Payload:", JSON.stringify(payload, null, 2));

      // Send API request
      const response = await postDataWithBody(CreateSopInstance, payload, {});

      if (response && response.status === "success") {
        toast.success(
          `${response.msg} (SOP ID: ${response.id})` || t("Sop incident created successfully"),
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          }
        );
        navigate("../Sop-instance-list");
      } else {
        toast.error(response?.msg || t("Failed to execute SOP"), {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Execute SOP error:", error);
      toast.error(t("execution_error") || "Failed to execute SOP", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
    }
  };

  const handleExecuteSop = () => {
    ExecuteSop();
  };

  const getDropdownColor = (priority) => {
    switch (priority) {
      case "Low":
        return "#b2eafe"; // Blue for low priority
      case "Medium":
        return "#fccd7c"; // Yellow for medium priority
      case "High":
        return "#f16a87"; // Red for high priority
      default:
        return "#13845d"; // Default color
    }
  };

  const tableColumns = React.useMemo(
    () => [
      {
        Header: t("executesopstableheaders.name"),
        accessor: "name",
        disableSortBy: true,
      },
      {
        Header: t("executesopstableheaders.tasktype"),
        accessor: "type",
        disableSortBy: true,
        // Cell: ({ value }) => (value === 0 ? "Activity" : "Notification"),
      },
      {
        Header: t("executesopstableheaders.incidenttype"),
        accessor: "incidenttype",
        disableSortBy: true,
      },
      {
        Header: t("executesopstableheaders.assignedto"),
        accessor: "assignedto",
        disableSortBy: true,
      },
      {
        Header: t("executesopstableheaders.priority"),
        accessor: "task_status_code",
        disableSortBy: true,
        Cell: ({ row }) => {
          const rowId = row.original.id;
          const priorityValue = row.original.priority || "Low";

          const handleSelectChange = (e) => {
            const newPriority = e.target.value;
            handlePriorityChange(rowId, newPriority);
          };

          return (
            <div style={{ position: "relative", width: "120px" }}>
              <select
                value={priorityValue}
                onChange={handleSelectChange}
                style={{
                  padding: "5px",
                  paddingRight: "20px", // Add padding for the arrow
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  backgroundColor: getDropdownColor(priorityValue),
                  color: "black",
                  width: "100%",
                  textAlign: "center",
                  textAlignLast: "center",
                  appearance: "none", // Remove default styling
                  WebkitAppearance: "none"
                }}
              >
                <option value="Low" style={{ textAlign: "center", backgroundColor: "white", color: "black" }}>
                  {t("Low")}
                </option>
                <option value="Medium" style={{ textAlign: "center", backgroundColor: "white", color: "black" }}>
                  {t("Medium")}
                </option>
                <option value="High" style={{ textAlign: "center", backgroundColor: "white", color: "black" }}>
                  {t("High")}
                </option>
              </select>
              <div
                style={{
                  position: "absolute",
                  right: "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  fontSize: "10px", // Make the arrow smaller
                  color: "black" // Match text color
                }}
              >
                ▼
              </div>
            </div>
          );
        },
      },
      {
        Header: t("executesopstableheaders.selecttask"),
        accessor: "isSelected",
        disableSortBy: true,
        Cell: ({ row }) => (
          <input
            type="checkbox"
            checked={row.original.isSelected || false}
            onChange={(e) =>
              handleTaskSelection(row.original.id, e.target.checked)
            }
          />
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, userTaskData]
  );

  const downloadAttachmentURL = `${process.env.REACT_APP_APP_SERVER_ADDRESS}/${process.env.REACT_APP_CORE_CONTEXT_PATH_NAME}/download/download_attachments/?directoryPath=${mediaFilePath}&fileName=Tasks.zip`;

  const tabsContent = generateTabsContent(sopFormConfig);

  return (
    <>
      <>
        <div className="mt-4">
          <Loader
            show={isLoading}
            type="body"
            stack="vertical"
            message="Loading Data"
          />

          <div className="form-body">
            {autoSopIncident?.autoSopFailure && (
              <div
                style={{
                  margin: "16px 16px 22px",
                  padding: "14px 16px",
                  background: "#FFF7ED",
                  border: "1px solid #FED7AA",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                }}
              >
                <span style={{ fontSize: "16px", lineHeight: 1.2 }}>⚠️</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "space-between",
                      gap: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    <div style={{ fontSize: "13px", fontWeight: 700, color: "#9A3412" }}>
                      Auto SOP execution failed
                    </div>
                    {autoSopIncident.autoSopFailure.created_on && (
                      <div style={{ fontSize: "11px", color: "#9A3412", opacity: 0.9, whiteSpace: "nowrap" }}>
                        {formatFailureTime(autoSopIncident.autoSopFailure.created_on)}
                      </div>
                    )}
                  </div>
                  {autoSopIncident.autoSopFailure.remarks && (
                    <div style={{ fontSize: "12px", color: "#7C2D12", marginTop: "8px", lineHeight: 1.5 }}>
                      <span style={{ fontWeight: 700 }}>SOP execution remarks:</span>{" "}
                      {autoSopIncident.autoSopFailure.remarks}
                    </div>
                  )}
                  <div style={{ fontSize: "12px", color: "#7C2D12", marginTop: "8px", fontWeight: 600 }}>
                    Review the details below and run the SOP manually.
                  </div>
                </div>
              </div>
            )}
            <div className="registration__form--body">
              <form
                onSubmit={handleSubmit(handleFormSubmit)}
                name="CreateTaskRegForm"
              >
                <div>
                  {tabsContent?.map((tab) => (
                    <div key={tab.id}>
                      {tab.id === activeTabIndex && <div>{tab.component}</div>}
                    </div>
                  ))}
                </div>

                {/* SOP Resources Table */}
                {sopResources.length > 0 && (
                  <div className="px-3 pb-3 mt-3">
                    <div style={{ borderRadius: "12px", overflow: "hidden", border: "1px solid #000" }}>
                      {/* Header */}
                      <div
                        className="d-flex align-items-center px-3 py-2"
                        style={{
                          background: "#1C4E72",
                          cursor: "pointer",
                          userSelect: "none"
                        }}
                        onClick={() => setIsResourcesExpanded(prev => !prev)}
                      >
                        <span style={{ color: "#fff", fontWeight: "700", fontSize: "13px", letterSpacing: "0.02em" }}>
                          Selected Resources for SOP
                        </span>
                        <span className="ms-auto me-2" style={{
                          background: "rgba(255,255,255,0.2)",
                          color: "#fff",
                          fontSize: "11px",
                          fontWeight: "600",
                          borderRadius: "20px",
                          padding: "2px 10px",
                          border: "1px solid rgba(255,255,255,0.3)",
                        }}>
                          {Object.values(checkedResources).filter(Boolean).length} / {sopResources.length} Selected
                        </span>
                        <span style={{
                          color: "#fff",
                          fontSize: "14px",
                          lineHeight: 1,
                          transition: "transform 0.25s ease",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transform: isResourcesExpanded ? "rotate(0deg)" : "rotate(-90deg)"
                        }}>
                          &#x25BE;
                        </span>
                      </div>

                      {/* Collapsible body */}
                      {isResourcesExpanded && (
                        <>
                          {/* Column Labels */}
                          <div className="d-flex align-items-center px-4 py-2" style={{
                            background: "#f5f7fa",
                            borderBottom: "1px solid #dbe4f0"
                          }}>
                            <div style={{ width: "40px", flexShrink: 0 }}>
                              <input
                                type="checkbox"
                                checked={sopResources.every((r, i) => checkedResources[r.resourceId ?? i])}
                                onChange={(e) => {
                                  const all = {};
                                  sopResources.forEach((r, i) => { all[r.resourceId ?? i] = e.target.checked; });
                                  setCheckedResources(all);
                                }}
                                onClick={e => e.stopPropagation()}
                                style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: "#1C4E72" }}
                              />
                            </div>
                            <div style={{ flex: 1, color: "#1C4E72", fontWeight: "600", fontSize: "11px", fontStyle: "normal" }}>Resource Name</div>
                            <div style={{ width: "200px", color: "#1C4E72", fontWeight: "600", fontSize: "11px", fontStyle: "normal" }}>Facility Name</div>
                            <div style={{ width: "80px", textAlign: "center", color: "#1C4E72", fontWeight: "600", fontSize: "11px", fontStyle: "normal" }}>Deployed</div>
                            <div style={{ width: "80px", textAlign: "center", color: "#1C4E72", fontWeight: "600", fontSize: "11px", fontStyle: "normal" }}>Damaged</div>
                            <div style={{ width: "80px", textAlign: "center", color: "#1C4E72", fontWeight: "600", fontSize: "11px", fontStyle: "normal" }}>Available</div>
                            <div style={{ width: "80px", textAlign: "center", color: "#1C4E72", fontWeight: "600", fontSize: "11px", fontStyle: "normal" }}>Total</div>
                          </div>
                          {/* Rows */}
                          <div style={{ background: "#fff", maxHeight: "320px", overflowY: "auto" }}>
                            {sopResources.map((res, index) => {
                              const key = res.resourceId ?? index;
                              const isChecked = !!checkedResources[key];
                              return (
                                <div
                                  key={key}
                                  className="d-flex align-items-center px-4 py-2"
                                  style={{
                                    borderBottom: index < sopResources.length - 1 ? "1px solid #f0f4f8" : "none",
                                    background: isChecked ? "#f0fbfa" : "#fff",
                                    cursor: "pointer",
                                    transition: "background 0.15s",
                                  }}
                                  onMouseEnter={e => { if (!isChecked) e.currentTarget.style.background = "#f7f9fc"; }}
                                  onMouseLeave={e => { e.currentTarget.style.background = isChecked ? "#f0fbfa" : "#fff"; }}
                                  onClick={() => setCheckedResources(prev => ({ ...prev, [key]: !prev[key] }))}
                                >
                                  <div style={{ width: "40px", flexShrink: 0 }}>
                                    <input
                                      type="checkbox"
                                      checked={isChecked}
                                      onChange={() => setCheckedResources(prev => ({ ...prev, [key]: !prev[key] }))}
                                      onClick={e => e.stopPropagation()}
                                      style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: "#1C4E72" }}
                                    />
                                  </div>
                                  <div style={{ flex: 1, fontWeight: isChecked ? "600" : "400", fontSize: "11px", fontStyle: "normal", color: isChecked ? "#1C4E72" : "#1a2e35" }}>
                                    {res.resource_name || "NA"}
                                  </div>
                                  <div style={{ width: "200px", fontSize: "11px", fontStyle: "normal", color: "#6b7a99", fontWeight: "400" }}>{res.facility_name || "NA"}</div>
                                  <div style={{ width: "80px", textAlign: "center", fontSize: "11px", color: "#1a2e35" }}>{res.cum_deployed_quantity ?? 0}</div>
                                  <div style={{ width: "80px", textAlign: "center", fontSize: "11px", color: "#1a2e35" }}>{res.cum_damaged_quantity ?? 0}</div>
                                  <div style={{ width: "80px", textAlign: "center", fontSize: "11px", color: "#1a2e35" }}>{res.cum_available_quantity ?? 0}</div>
                                  <div style={{ width: "80px", textAlign: "center", fontSize: "11px", color: "#1a2e35" }}>{res.cum_total_quantity ?? 0}</div>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}

                {taskId && mediaFilePath && (
                  <div className="multi_file_uploaded cursor-pointer">
                    <div
                      onClick={() =>
                        downloadFile(
                          downloadAttachmentURL,
                          `Tasks${Date.now()}.zip`
                        )
                      }
                    >
                      <PaperClipIcon className="cursor-pointer" /> Attached
                      files
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>

        <div>
          <Loader show={isLoading} type="body" message="Loading Data" />

          <ExecuteSopsExpandableTable
            data={userTaskData}
            columns={tableColumns}
            numberOfRows={7}
            regionId={selectedRegionId}
            showExport={false}
            showFilter={false}
            showReset={false}
            onExpand={false}
            rowCount={rowCount}
            headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF" }}
            tableStyle={{
              //border: "1px solid #f0f0f0",
              borderRadius: "12px",
            }}
          />
        </div>
      </>
      <>
        <div
          className="d-flex"
          style={{ marginTop: "-4.5rem", marginLeft: "10pt" }}
        >
          <Button
            style={{
              fontSize: "10pt",
              paddingLeft: "2rem",
              paddingRight: "2rem",
              marginTop: "80px",
            }}
            onClick={handleExecuteSop}
            type="button"
            className="mx-2"
            variant="primary"
            disabled={isSubmitting || isLoading || !hasSelectedTasks} // Disable button if no tasks are selected
          >
            {isSubmitting ? t("Executing...") : t("Execute SOP")}
          </Button>
        </div>
      </>
      <ToastContainer />
    </>
  );
};

export default ExecuteSopsForm;